// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__+MWmv"};